import type { SidePanelLayout } from './sidePanelColumn/sidePanelLayout';
import type { I18nLocale } from '@ardoq/i18n';

export type PayloadShowAppModule = {
  readonly selectedModule: AppModules;
};

export enum AppModules {
  DASHBOARDS = 'dashboards',
  HOME = 'home',
  INTEGRATIONS = 'integrations',
  SEARCH = 'search',
  PRESENTATIONS = 'presentations',
  SURVEY_ADMIN = 'survey_admin',
  WORKSPACES = 'workspaces',
  METAMODEL = 'metamodel',
  ORGANIZATION_METAMODEL = 'organization-metamodel',
  TASKS = 'tasks',
  BROADCASTS = 'broadcasts',
  VIEWPOINTS = 'viewpoints',
  REPORTS = 'report',
  MANAGE_ORGANIZATION = 'manage-organization',
  ACCESS_CONTROL_V2 = 'access-control',
  USER_SETTINGS = 'account-settings',
  AUDIT_LOG = 'audit-log',
  USE_CASES = 'use-cases',
  COMPONENT_OVERVIEW_PAGE = 'component-overview-page',
  ANALYTICS = 'analytics',
  INVENTORY = 'inventory',
  EXTERNAL_DOCUMENT = 'external-document',
  DISCOVER_LANDING_PAGE = 'discover-landing-page',
  HELP_AND_SUPPORT = 'help-and-support',
  WORKSPACE_MANAGER = 'workspace-manager',
  FIELD_DETAILS = 'field-details',
  COMPONENT_TYPE_DETAILS = 'component-type-details',
  ASSET_LIBRARY = 'asset-library',
  SOLUTIONS = 'solutions',
  TRANSFORMATIONS = 'transformations',
  APPLICATION_COMPLETENESS = 'application-completeness',
  PRODUCT_TOUR = 'product-tour',
}

export type TrialTermsBannerProps = {
  onAcceptTerms: () => void;
};

export type AppContainerProps = {
  trialTermsBanner?: TrialTermsBannerProps;
  hasNewSidebarAndNavbar: boolean;
  isModuleAccessible: boolean;
  i18nLocale: I18nLocale;
  sidePanelLayout: SidePanelLayout;
  showSandboxIndicator: boolean;
  showEphemeralNotificationsDevTool: boolean;
};
